import { styled } from '@vw-marketing/us-components';

export const StyledConfirmationWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static350};
    `;
  }}
`;

export const StyledContent: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static150};
    `;
  }}
`;

export const StyledSubtitle: any = styled.div`
  font-weight: 300;
`;


export const StyledButtonsContainer: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static200};
    `;
  }}
`;
